module.exports = __webpack_public_path__ + "static/media/luoshan_plant.ea85063b.png";